import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=bbf60e36&scoped=true&"
import script from "./Step6.vue?vue&type=script&lang=ts&"
export * from "./Step6.vue?vue&type=script&lang=ts&"
import style0 from "./Step6.vue?vue&type=style&index=0&id=bbf60e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf60e36",
  null
  
)

export default component.exports